module.exports = __webpack_public_path__ + "img/img-widget-group.53487e3e.svg";